var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2383_1729)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5713 32.7146C35.0943 31.7055 36.3373 30.4444 37.1093 28.7614C37.3905 28.1472 37.394 28.1472 36.7262 28.1472C34.464 28.1472 32.2018 28.132 29.9396 28.1578C29.471 28.1578 29.3538 28.0148 29.3538 27.5636C29.3796 25.9638 29.3831 24.364 29.3538 22.7654C29.3456 22.2872 29.5026 22.1887 29.9489 22.1899C34.3757 22.2047 38.8025 22.2047 43.2293 22.1899C43.6077 22.1899 43.7647 22.2696 43.8233 22.6786C44.4946 27.3667 43.2516 31.4758 40.1459 35.027C39.6211 35.6259 39.0704 36.2119 38.3886 36.6549L33.5713 32.7146Z",
    fill: "#6287C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.748 18.1047C17.899 14.0449 21.2191 11.4383 25.6744 10.4116C30.2 9.36855 34.3647 10.3261 38.1171 13.0768C38.5154 13.3698 38.56 13.5245 38.1406 13.855C36.7769 14.9274 35.4461 16.0385 34.1082 17.1484C33.8516 17.3629 33.6653 17.3922 33.3502 17.2211C28.527 14.6039 22.7479 16.71 20.7106 21.8107C20.6743 21.9009 20.6286 21.9876 20.5935 22.0755L15.748 18.1047Z",
    fill: "#EF4539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5744 32.7127L38.4011 36.6542C36.7 38.1215 34.7201 39.0275 32.5575 39.5713C26.011 41.218 18.819 37.9914 15.8223 32.0634C15.9769 31.9462 16.1374 31.8372 16.2909 31.7118L20.69 28.1442C22.0536 31.3895 24.4517 33.3292 27.9534 33.8331C29.6943 34.0839 31.3649 33.7698 32.9488 33.0022C33.1503 32.9037 33.3647 32.81 33.5744 32.7127Z",
    fill: "#31B44B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6824 28.1454L16.2834 31.713C16.1334 31.8302 15.9729 31.9474 15.8147 32.0646C13.4354 27.4222 13.385 22.7682 15.7421 18.1012L20.5805 22.072C19.9678 24.1043 19.9561 26.1307 20.6824 28.1454Z",
    fill: "#F8BB18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2383_1729",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2383_1729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2383_1729",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglIcon);
export default __webpack_public_path__ + "static/media/googl-Icon.ec3dad9b296bc0b2ff55aa4f5c61ae10.svg";
export { ForwardRef as ReactComponent };